<div class="login">
  <div class="login-form">
    <div class="page-header">
      <div class="logo"></div>
    </div>

    <form [formGroup]="form">
      <hr>
        <h4 class="h4" translate>Welcome!</h4>
        <p class="text-muted mb-4" translate>Please enter your details to access your account.</p>
        <!-- USERNAME -->
        <div class="form-group">
          <label class="sr-only" for="loginInputEmail" translate>E-mail address</label> <!--Email address-->

          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><span class="fa-solid fa-user"></span></span>
            </div>
            <input [ngClass]="{ 'is-invalid': f.username.errors }"
              (keyup.enter)="onFirebaseSignIn()"
              class="form-control"
              formControlName="username"
              id="loginInputEmail"
              placeholder="E-mail"
              type="email">
            </div>
            @if (f.username.errors) {
              <div class="invalid-feedback">
                @if (f.username.errors.required) {
                  <div translate>Username is required</div>
                }
              </div>
            }
          </div>
          <!-- PASSWORD -->
          <div class="form-group mb-0">
            <label class="sr-only" for="loginInputPassword" translate>Password</label>

            <div class="input-group input-group-pw">
              <div class="input-group-prepend">
                <span class="input-group-text"><span class="fa-solid fa-lock"></span></span>
              </div>
              <input [ngClass]="{ 'is-invalid': f.password.errors }"
                (keyup.enter)="onFirebaseSignIn()"
                class="form-control"
                formControlName="password"
                id="loginInputPassword"
                placeholder="Password"
                type="{{isPasswordVisible ? 'text': 'password'}}">
                @if (!f.password.errors) {
                  <span (click)="onShowPasswordChange()"
                [ngClass]="{'fa-eye-slash':!isPasswordVisible,
                                        'fa-eye': isPasswordVisible}"
                    class="far btn-show-hide-pw">
                  </span>
                }
              </div>
              @if (f.password.errors) {
                <div class="invalid-feedback">
                  @if (f.password.errors.required) {
                    <div translate>Password is required</div>
                  }
                </div>
              }
            </div>

            <a (click)="resetPassword()"
              [title]="resetPasswordTitle"
              class="text-left">
              <span style="font-size: 12px" translate>Forgot password?</span>
            </a>

            <!-- FIREBASE SIGN-IN BUTTON -->
            <div class="form-group mt-2">
              <button (click)="onFirebaseSignIn()" [disabled]="shouldDisableSignInButton"
                class="btn btn-primary btn-md btn-block"
                type="button">
                <span translate>Login</span>
                @if (signInPending) {
                  <span>
                    <em class="fa-solid fa-spinner fa-spin"></em>
                  </span>
                }
              </button>
            </div>

            @if (showErrors) {
              <div class="alert alert-danger mb-0" role="alert">
                <strong class="d-block" translate>Login failed</strong>
                <p class="mb-0" translate>Unknown username or wrong password, or invalid captcha response.</p>
              </div>
            }
            <br>
              <div class="login-divider">
                <span class="text-muted" translate>Or</span>
              </div>

              <!-- GOOGLE SIGN-IN BUTTON -->
              <button (click)="onGoogleSignIn()" class="btn btn-outline-secondary btn-md btn-block"
                type="button">
                <span class="fab fa-google"></span>
                <span class="ml-2">Login with Google </span>
                @if (googleSignInPending) {
                  <span><em class="fa-solid fa-spinner fa-spin"></em></span>
                }

              </button>
              <div>
                <p class="text-muted mt-3" style="font-size: 11px" translate>
                  This site is protected by reCAPTCHA and the Google
                  <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                  <a href="https://policies.google.com/terms">Terms of Service</a> apply.</p>
                </div>
              </form>
            </div>
          </div>

